import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 80px auto;
  width: 90%;
  max-width: 500px;
  background: #2a3142;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
`;

export const Header = styled.div`
  background: #626ed4;
  padding: 80px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  h4 {
    font-size: 20px;
    color: #fff;
  }

  p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 10px;
  }

  div {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    bottom: -50px;
    background: #2a3142;
    border-bottom: 2px solid #626ed4;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
